import { render, staticRenderFns } from "./ExpertFeesIndex.vue?vue&type=template&id=3290a0e4&scoped=true"
import script from "./ExpertFeesIndex.vue?vue&type=script&lang=js"
export * from "./ExpertFeesIndex.vue?vue&type=script&lang=js"
import style0 from "./ExpertFeesIndex.vue?vue&type=style&index=0&id=3290a0e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3290a0e4",
  null
  
)

export default component.exports